/* ==========================================================================
   Owl & Twig — Night reading (v41), uranium added (v42)
   Loaded only on the Field Guide index and article pages.

   The attribute itself is set by a small inline script in layout/theme.liquid
   so it lands before first paint — without that there is a white flash on
   every load, which rather defeats the point. This file only builds the
   button and handles the tap.

   Storage key is shared with Prowl on purpose ('prowl.theme'), so a reader who
   sets dark on a guide finds Prowl already dark, and the other way round.
   v42: the button now cycles the same three modes Prowl does, in the same
   order — light, dark, uranium — so the two never disagree about what a tap
   does next. The button names the mode it will switch TO.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'prowl.theme';
  var MODES = ['light', 'dark', 'uranium'];
  var META = { light: '#0b3d2e', dark: '#14130f', uranium: '#0a0e2e' };
  var NEXT = {
    light:   { ico: '☾', lbl: 'Night',   aria: 'Switch to night reading' },
    dark:    { ico: '🍄', lbl: 'Uranium', aria: 'Switch to uranium mode' },
    uranium: { ico: '☀', lbl: 'Day',     aria: 'Switch to day reading' }
  };
  var root = document.documentElement;

  function current() {
    var t = root.getAttribute('data-theme');
    return MODES.indexOf(t) > -1 ? t : 'light';
  }

  function apply(mode) {
    if (MODES.indexOf(mode) === -1) mode = 'light';
    if (mode === 'light') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', mode);
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    var m = document.querySelector('meta[name=theme-color]');
    if (m) m.setAttribute('content', META[mode]);
    paint();
  }

  var btn = null;

  function paint() {
    if (!btn) return;
    var n = NEXT[current()];
    btn.querySelector('.owt-night-ico').textContent = n.ico;
    btn.querySelector('.owt-night-lbl').textContent = n.lbl;
    btn.setAttribute('aria-label', n.aria);
    btn.title = n.aria;
  }

  function build() {
    if (document.querySelector('.owt-night-toggle')) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'owt-night-toggle';
    btn.innerHTML = '<span class="owt-night-ico" aria-hidden="true"></span>' +
                    '<span class="owt-night-lbl"></span>';
    btn.addEventListener('click', function () {
      var i = MODES.indexOf(current());
      apply(MODES[(i + 1) % MODES.length]);
    });
    document.body.appendChild(btn);
    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();